import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id C7FF59F8-8D2F-4866-B8D3-27ED83C324F0
 * name leaf-maple
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/leaf-maple.svg
 * tags
 * - Nature 
 * - Agriculture 
 */
export const LeafMapleIcon = createSvgIcon(<><path d="M21.79,13L16,16L17,18L13,17.25V21H11V17.25L7,18L8,16L2.21,13L3.21,11.27L1.61,8L5.21,7.77L6.21,6L9.63,9.9L8,5H10L12,2L14,5H16L14.37,9.9L17.79,6L18.79,7.73L22.39,7.96L20.79,11.19L21.79,13Z" /></>, 'LeafMapleIcon');
export default LeafMapleIcon